export default "__VITE_ASSET__216f6e2f__"